<template>
  <div v-if="(!isEdit && charge[1]) || isEdit" class="mb-2">
    <div class="z-border-red pa-2">
      <v-layout>
        <v-flex>
          <img
            :src="
              '/static/img/assets/payment/' +
              (name.includes('other') ? 'other_charge' : name) +
              '_logo.png'
            "
            alt
            style="height: 50px; vertical-align: middle"
            class="mr-2 mb-2"
          />
          <div class="clearfix hidden-sm-and-up"></div>
          <template v-if="name.includes('other')">
            {{ otherName }}
          </template>
          <template v-else-if="name.includes('cod_charge') && codName">
            {{ codName }}
          </template>
          <template v-else>
            {{ $t(name) }}
          </template>
        </v-flex>
        <v-flex class="text-xs-right">
          <template v-if="isEdit">
            <label class="toggle-switch small" style="vertical-align: middle">
              <input type="checkbox" @change="onChangeStatus" :checked="charge[1]" />
              <span class="toggle-slider lever round"></span>
            </label>
          </template>
          <template v-else>
            <v-chip v-if="charge[1]" color="green" class="white--text" small disabled>{{
              $t('active')
            }}</v-chip>
            <v-chip v-else color="red" class="white--text" small disabled>{{
              $t('inactive')
            }}</v-chip>
          </template>

          <span @click="isShow = !isShow" style="cursor: pointer">
            <v-icon v-if="!isShow">keyboard_arrow_down</v-icon>
            <v-icon v-else>keyboard_arrow_up</v-icon>
          </span>
        </v-flex>
      </v-layout>
      <div v-show="isShow">
        <v-divider class="mb-3"></v-divider>
        <template v-if="isEdit && (name.includes('other') || name.includes('cod_charge'))">
          <div class="form-control">
            <div class="caption">{{ $t('Shipping Name') }}</div>
            <input
              type="text"
              maxlength="255"
              v-model="charge[9]"
              v-if="name.includes('cod_charge')"
            />
            <input type="text" maxlength="255" v-model="charge[4]" v-else />
          </div>
        </template>
        <template v-if="name != 'additionalproduct_charge'">
          <v-layout wrap>
            <v-flex xs12 sm3 full-height class="form-control pa-1 border-right">
              <div class="caption">{{ $t('Shipping Fee (Standard)') }}</div>
              <template v-if="isEdit">
                <input type="number" pattern="[0-9]*" inputmode="numeric" v-model="charge[0]" />
              </template>
              <div class="primary--text" v-else-if="charge[0] != 0">
                ฿{{ charge[0] | decimalFormat }}
              </div>
              <div class="primary--text" v-else>{{ $t('Free') }}</div>
            </v-flex>
            <v-flex xs12 sm9 class="pa-1 pb-3">
              <div class="caption">{{ $t('Shipping Fee (Weight-based)') }} ({{ $t('gram') }})</div>
              <template v-if="charge && charge[2] && charge[2].length > 0">
                <template v-for="(weight, index) in charge[2]">
                  <shipping-detail-weight
                    :position="index"
                    v-model="charge[2][index]"
                    :key="'weight_' + index + '_' + timestamp"
                    :isEdit="isEdit"
                    :minWeight="
                      index > 0
                        ? charge[2][index - 1].max
                          ? parseFloat(charge[2][index - 1].max)
                          : 0
                        : null
                    "
                    :lastPrice="
                      index > 0
                        ? charge[2][index - 1].price
                          ? parseFloat(charge[2][index - 1].price)
                          : 0
                        : 0
                    "
                    @onChangeValue="onChangeValue"
                    @onDelete="onDeleteShippingWeight(index)"
                  ></shipping-detail-weight>
                </template>
              </template>
              <div
                class="primary--text pa-1"
                v-else-if="charge && charge[2] && charge[2].length == 0 && !isEdit"
              >
                {{ $t('No Weight-based delivery') }}
              </div>
              <div
                class="btn-add text-xs-center"
                v-if="isEdit"
                style="cursor: pointer"
                @click="addShippingWeight"
              >
                <v-icon class="mr-1" style="verticle-align: middle">add</v-icon>
                {{ $t('Add') }}
              </div>
            </v-flex>
            <v-flex sm12>
              <v-divider />
            </v-flex>
            <v-flex xs12 :sm6="name == 'cod_charge'" class="pt-3 pl-1">
              <div class="form-control">
                <label>{{ $t('Additional Charge per item') }}</label>
                <div v-if="isEdit">
                  <input type="number" v-model.number="charge[3]" />
                </div>
                <div v-else class="primary--text">
                  {{ charge[3] }}
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 v-if="name == 'cod_charge'" class="pt-3 pl-1">
              <label>{{ $t('Shipping Fee (Percent)') }}</label>
              <div class="form-control" v-if="isEdit">
                <v-layout>
                  <v-flex>
                    <input
                      type="number"
                      pattern="[0-9]*"
                      inputmode="numeric"
                      min="0"
                      max="100"
                      v-model="percentCharge"
                      @blur="onBlurNumber"
                    />
                  </v-flex>
                  <v-flex shrink class="pa-2"> % </v-flex>
                </v-layout>
              </div>
              <div class="primary--text" v-else>{{ charge[4] ? charge[4] : '-' }}</div>
            </v-flex>
          </v-layout>
        </template>
        <template v-else>
          <div class="form-control pa-1">
            <div class="caption">{{ $t('shipping fee') }}</div>
            <template v-if="isEdit">
              <input type="text" pattern="[0-9]*" inputmode="numeric" v-model="charge[0]" />
            </template>
            <div class="primary--text" v-else-if="charge[0] != 0">
              ฿{{ charge[0] | decimalFormat }}
            </div>
            <div class="primary--text" v-else>{{ $t('Free') }}</div>
          </div>
        </template>
        <v-divider></v-divider>
        <div class="caption pa-1">
          {{
            $t(
              'Note: Total Shipping Fee will be included Shipping Fee (Standard) and Shipping Fee (Weight-based)'
            )
          }}
        </div>
      </div>

      <div
        class="error--text caption"
        v-if="selectedBot.shippop_status == true && ['dhl_charge', 'nikos_charge'].includes(name)"
      >
        ไม่รองรับการขนส่งผ่านระบบ Shippop
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShippingDetailWeight from './ShippingDetailWeight'
import moment from 'moment'
export default {
  props: ['value', 'isEdit', 'name'],
  inject: ['$validator'],
  data: function () {
    return {
      charge: this.value,
      isShow: false,
      chargeType: 'normal',
      percentCharge: 0,
      timestamp: moment().format('x')
    }
  },

  components: {
    ShippingDetailWeight
  },
  mounted() {
    if (this.name == 'cod_charge') {
      if (this.charge[4] != '') {
        this.chargeType = 'percent'
        var percent = this.charge[4]
        try {
          percent = percent.replace('%', '')
          percent = parseInt(percent)
          this.percentCharge = percent
        } catch (error) {
          percent = 0
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    otherName() {
      if (this.charge[4] && this.charge[4].includes('Other')) {
        if (this.charge[4].match(/\d+/g)) {
          return this.$t('other_charge') + ' ' + this.charge[4].match(/\d+/g).map(Number)[0]
        } else {
          return this.$t('other_charge')
        }
      } else {
        return this.charge[4]
      }
    },
    codName() {
      return this.charge[9]
    }
  },
  methods: {
    onChangeValue() {
      this.timestamp = moment().format('x')
    },
    onBlurNumber(el) {
      try {
        if (el.target) {
          var number = parseInt(el.target.value)
          if (number < 0) {
            el.target.value = 0
          } else if (number > 100) {
            el.target.value = 100
          }
        }
      } catch (error) {
        el.target.value = 0
      }

      this.$set(this.charge, 4, el.target.value ? el.target.value + '%' : '')
      this.$emit('input', this.charge)
    },
    onChangeStatus() {
      this.$set(this.charge, 1, !this.charge[1])
      this.$emit('input', this.charge)
    },
    addShippingWeight() {
      this.charge[2].push({ min: null, max: null, charge: null })
      this.$emit('input', this.charge)
    },
    onDeleteShippingWeight(index) {
      this.charge[2].splice(index, 1)
    }
  },
  watch: {
    chargeType(newVal) {
      if (this.name == 'cod_charge' && newVal == 'normal') {
        this.$set(this.charge, 4, '')
        this.$emit('input', this.charge)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 600px) {
  .border-right {
    border-right: 1px solid #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/ShippingDetailItem.vue